import { zodResolver } from '@hookform/resolvers/zod'
import Box from '@repo/ui/box'
import { useForm } from 'react-hook-form'

import useTranslate from '../../../lib/hooks/use-translate'
import { TeflInput } from '../../../lib/types/models/tefl/tefl-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form } from '../../elements/forms/form'
import ValidationButtons from '../../elements/validation-buttons'
import TeflDetailsForm from './tefl-details-form'
import TeflDiplomaTableForm from './tefl-diploma-table-form'
import TeflDocumentsForm from './tefl-documents-form'
import TeflTeachExperienceForm from './tefl-teach-experience-form'
import { teflFormSchema } from './utils'

const TeflForm = ({ defaultValues, ...validationButtonProps }: BaseFormProps<TeflInput, true>) => {
  const { t } = useTranslate()
  const form = useForm<TeflInput>({
    resolver: zodResolver(teflFormSchema(t)),
    defaultValues: defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <Box>
        <form
          onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}
          className="flex flex-col gap-4"
        >
          <div className="grid grid-cols-2 gap-3">
            <div className="flex flex-col gap-4">
              <TeflDetailsForm />
            </div>
            <div className="flex flex-col gap-4">
              <TeflTeachExperienceForm />
              <TeflDocumentsForm />
            </div>
          </div>
          <TeflDiplomaTableForm />

          <ValidationButtons {...validationButtonProps} />
        </form>
      </Box>
    </Form>
  )
}

export default TeflForm
